/* @NOTE Contents of this file is *generated*, DO NOT EDIT */
import type { DocumentManifest, DocumentPage } from '@shared/docs/types';

export const pages: DocumentPage[] = [
	{
		url: '/docs',
		source: 'docs/README.md',
		segments: [],
		version: null,
		title: '360Player Documentation',
		frontmatter: {},
		load: () =>
			import('../../../docs/README.md', { with: { type: 'text' } }).then(
				(module) => module.default
			),
	},
	{
		url: '/docs/authentication',
		source: 'docs/authentication/README.md',
		segments: ['authentication'],
		version: null,
		title: 'Authentication',
		frontmatter: { order: '2', group: 'Guides' },
		load: () =>
			import('../../../docs/authentication/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/docs/errors',
		source: 'docs/errors/README.md',
		segments: ['errors'],
		version: null,
		title: 'Errors',
		frontmatter: { order: '7', group: 'Guides' },
		load: () =>
			import('../../../docs/errors/README.md', { with: { type: 'text' } }).then(
				(module) => module.default
			),
	},
	{
		url: '/docs/getting-started',
		source: 'docs/getting_started/README.md',
		segments: ['getting-started'],
		version: null,
		title: 'Getting started',
		frontmatter: { order: '1', group: 'Guides' },
		load: () =>
			import('../../../docs/getting_started/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/docs/groups-and-scopes',
		source: 'docs/groups_and_scopes/README.md',
		segments: ['groups-and-scopes'],
		version: null,
		title: 'Groups and scopes',
		frontmatter: { order: '3', group: 'Guides' },
		load: () =>
			import('../../../docs/groups_and_scopes/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/docs/keys',
		source: 'docs/keys/README.md',
		segments: ['keys'],
		version: null,
		title: 'Keys',
		frontmatter: { order: '4', group: 'Guides' },
		load: () =>
			import('../../../docs/keys/README.md', { with: { type: 'text' } }).then(
				(module) => module.default
			),
	},
	{
		url: '/docs/pagination-and-filtering',
		source: 'docs/pagination_and_filtering/README.md',
		segments: ['pagination-and-filtering'],
		version: null,
		title: 'Pagination and filtering',
		frontmatter: { order: '5', group: 'Guides' },
		load: () =>
			import('../../../docs/pagination_and_filtering/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/docs/rate-limits',
		source: 'docs/rate_limits/README.md',
		segments: ['rate-limits'],
		version: null,
		title: 'Rate limits',
		frontmatter: { order: '6', group: 'Guides' },
		load: () =>
			import('../../../docs/rate_limits/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/reference',
		source: 'reference/README.md',
		segments: [],
		version: null,
		title: 'API Reference',
		frontmatter: { order: '0', generated: 'true' },
		load: () =>
			import('../../../reference/README.md', { with: { type: 'text' } }).then(
				(module) => module.default
			),
	},
	{
		url: '/reference/keys/rotate',
		source: 'reference/keys/rotate/README.md',
		segments: ['keys', 'rotate'],
		version: null,
		title: 'Rotate a key',
		frontmatter: {
			order: '1',
			group: 'Keys',
			method: 'POST',
			endpoint: '/v1/keys/rotate',
			generated: 'true',
		},
		load: () =>
			import('../../../reference/keys/rotate/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/reference/oauth/token',
		source: 'reference/oauth/token/README.md',
		segments: ['oauth', 'token'],
		version: null,
		title: 'Get a token',
		frontmatter: {
			order: '2',
			group: 'Oauth',
			method: 'POST',
			endpoint: '/oauth/token',
			generated: 'true',
		},
		load: () =>
			import('../../../reference/oauth/token/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/reference/users/fields',
		source: 'reference/users/fields/README.md',
		segments: ['users', 'fields'],
		version: null,
		title: 'List custom user fields',
		frontmatter: {
			order: '4',
			group: 'Users',
			method: 'GET',
			endpoint: '/v1/users/fields',
			generated: 'true',
		},
		load: () =>
			import('../../../reference/users/fields/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
	{
		url: '/reference/users/list',
		source: 'reference/users/list/README.md',
		segments: ['users', 'list'],
		version: null,
		title: 'List users',
		frontmatter: {
			order: '3',
			group: 'Users',
			method: 'GET',
			endpoint: '/v1/users',
			generated: 'true',
		},
		load: () =>
			import('../../../reference/users/list/README.md', {
				with: { type: 'text' },
			}).then((module) => module.default),
	},
];

export const aliases: Record<string, string> = {};

const manifest: DocumentManifest = { pages, aliases };

export default manifest;

// Self-accepting so a markdown edit has a hot-update boundary to stop at.
// The docs are reached through the dynamic imports above, and a chunk with
// no accepting importer makes Bun fall back to a full page reload.
if (import.meta.hot) {
	import.meta.hot.accept();
}
